<template>
    <vx-expandable-card>
        <template v-slot:header> Two-Factor Authentication </template>

        <template v-slot:content>
            <div class="flex flex-col gap-6 mt-3">
                <vx-button block size="lg" @click.prevent="disable" :loading="submitting" color="danger">
                    Disable Two-Factor Authentication
                </vx-button>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import axios from '~/services/axios';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';

defineProps({
    user: {
        type: Object,
        required: true,
    },
});

const toasted = useToasted();
const submitting = ref(false);

const disable = () => {
    if (submitting.value) {
        return;
    }

    submitting.value = true;

    axios
        .delete('/settings/two-factor-auth')
        .then(() => {
            Bus.$emit('updateUser');
        })
        .catch((e) => {
            console.error(e);
            toasted.global.platform_error();
        })
        .finally(() => {
            submitting.value = false;
        });
};
</script>
